module.exports = __webpack_public_path__ + "media/public/images/icon-trigger-black-0de4102df99ad5207f2d02a085fcb595.svg";